import {  useEffect } from "react";
import { useLanguage } from 'contexts/LanguageContext'
import t from 'translation.json'

export interface IMetadata {
    page: keyof typeof t['fr']['pagesMetadata'];
}

export const useMetadata = (props: IMetadata) => {
    const {page } = props;
    const {res, lang} = useLanguage();

    useEffect(() => {
        document.title = res.pagesMetadata[page].title;
        document.querySelector('meta[name="description"]')?.setAttribute('content',  res.pagesMetadata[page].description);
      }, [page,lang]);

    return {
        ...props
    };
  };